import React, { Component } from 'react';
import { Label, Modal, Button } from 'semantic-ui-react';
import DatesWithProductionFromMultiplePracticesTable from "./DatesWithProductionFromMutliplePracticesTable";
import {connect} from "react-redux";

class ScheduledDaysLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };
    }

    handleLabelClick = () => {
        this.setState({ modalOpen: true });
    };

    handleCloseModal = () => {
        this.setState({ modalOpen: false });
    };

    getPracticeName = (practiceId) => {
        const { practiceListArray } = this.props;
        const practiceDetails = practiceListArray.find(item => item.id === practiceId);
        return practiceDetails ? practiceDetails.practice : '';
    }

    render() {
        const { scheduledDays, sameDateMultiplePractices } = this.props;
        const { modalOpen } = this.state;

        const mappedData = sameDateMultiplePractices
            ?.map(item =>({...item ,practiceNames: (item.practices)
                .map(practiceId => this.getPracticeName(practiceId))}))

        return (
            <React.Fragment>
                <Label
                    circular
                    color='red'
                    key='circular-label-scheduled'
                    onClick={this.handleLabelClick}
                    style={{ cursor: 'pointer' }}
                >
                    {scheduledDays}
                </Label>

                {modalOpen && <Modal open={modalOpen} onClose={this.handleCloseModal} size='tiny'>
                    <Modal.Header>Schedule Dates With Multiple Practices</Modal.Header>
                    <Modal.Content>
                        <DatesWithProductionFromMultiplePracticesTable data={mappedData}/>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>}
            </React.Fragment>
        );
    }
}

export default connect(state => ({
    practiceListArray:state.get('practices').get('practiceListArray'),
}))(ScheduledDaysLabel);